export default "__VITE_ASSET__C7md_HJu__"